<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Amount" prop="money" >
        <a-input-number v-model="money" :min="0" :step="0.01" style="width: 100%" placeholder="Please enter amount" />
      </a-form-model-item>
<!--      <a-form-model-item label="Email" prop="email" >-->
<!--        <a-input v-model="form.email" placeholder="Please enter email" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Password, md5" prop="password" >-->
<!--        <a-input v-model="form.password" placeholder="Please enter password, md5" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Avatar URL" prop="avatar" >-->
<!--        <a-input v-model="form.avatar" placeholder="Please enter avatar URL" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Nickname" prop="nickname" >-->
<!--        <a-input v-model="form.nickname" placeholder="Please enter nickname" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Gender, 0-Unknown 1-Male 2-Female" prop="sex" >-->
<!--        <a-select placeholder="Please select gender, 0-Unknown 1-Male 2-Female" v-model="form.sex">-->
<!--          <a-select-option v-for="(d, index) in sexOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Birthday, format 1990-04-22" prop="birthday" >-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="User Signature" prop="userSign" v-if="formType === 1">-->
<!--        <a-input v-model="form.userSign" placeholder="Please enter user signature" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Invitation Code" prop="invitationCode" >-->
<!--        <a-input v-model="form.invitationCode" placeholder="Please enter invitation code" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Push Enabled 1-Yes 0-No" prop="isNotice" >-->
<!--        <a-select placeholder="Please select push status 1-Yes 0-No" v-model="form.isNotice">-->
<!--          <a-select-option v-for="(d, index) in isNoticeOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="User Status, 1-Enabled, 0-Disabled" prop="status" >-->
<!--        <a-select placeholder="Please select user status, 1-Enabled, 0-Disabled" v-model="form.status">-->
<!--          <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="Remark" prop="remark" v-if="formType === 1">-->
<!--        <a-input v-model="form.remark" placeholder="Please enter content" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addAccount} from "@/api/biz/account";

export default {
  name: 'CreateForm',
  props: {
    sexOptions: {
      type: Array,
      required: true
    },
    isNoticeOptions: {
      type: Array,
      required: true
    },
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // Form params
      form: {
        id: null,

        mobile: null,

        email: null,

        password: null,

        avatar: null,

        nickname: null,

        sex: null,

        birthday: null,

        userSign: null,

        invitationCode: null,

        isNotice: null,

        status: null,

        createTime: null,

        remark: null,

      },
      // 1 add, 2 edit
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: 'Mobile number is required', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: 'Nickname is required', trigger: 'blur' }
        ],
        isNotice: [
          { required: true, message: 'Push status is required', trigger: 'change' }
        ],
        status: [
          { required: true, message: 'User status is required', trigger: 'change' }
        ]
      },
      userId:null,
      money:0
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // Cancel button
    cancel () {
      this.open = false
      this.reset()
    },
    // Reset form
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        mobile: null,
        email: null,
        password: null,
        avatar: null,
        nickname: null,
        sex: null,
        birthday: null,
        userSign: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        createTime: null,
        remark: null,
      }
      this.userId=null;
      this.money=0;
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** Add action */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Top Up';
    },
    /** Edit action */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2;
      this.formTitle = 'Top Up'
      const id = row ? row.id : ids;
      this.userId = id;
      this.open = true
      // getUser({ id }).then(response => {
      //   this.form = response.data
      //   this.open = true
      //   this.formTitle = 'Top Up'
      // })
    },
    /** Submit action */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          addAccount({
            userId:this.userId,
            money: this.money
          }).then(response => {
            this.$message.success(
              'Top up successful',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
          // if (this.form.id !== undefined && this.form.id !== null) {
          //   updateUser(this.form).then(response => {
          //     this.$message.success(
          //       'Updated successfully',
          //       3
          //     )
          //     this.open = false
          //     this.$emit('ok')
          //   }).finally(() => {
          //     this.submitLoading = false
          //   })
          // } else {
          //   addUser(this.form).then(response => {
          //     this.$message.success(
          //       'Added successfully',
          //       3
          //     )
          //     this.open = false
          //     this.$emit('ok')
          //   }).finally(() => {
          //     this.submitLoading = false
          //   })
          // }
        } else {
          return false
        }
      })
    }
  }
}
</script>
